var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.96,
    y: 50.39,
    width: 13.79,
    height: 13.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.61,
    y1: 57.07,
    x2: 166.61,
    y2: 57.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.96,
    y: 77.06,
    width: 13.79,
    height: 13.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.61,
    y1: 83.74,
    x2: 166.61,
    y2: 83.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.96,
    y: 103.73,
    width: 13.79,
    height: 13.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.61,
    y1: 110.41,
    x2: 166.61,
    y2: 110.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.96,
    y: 130.39,
    width: 13.79,
    height: 13.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.61,
    y1: 137.07,
    x2: 166.61,
    y2: 137.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.96,
    y: 157.06,
    width: 13.79,
    height: 13.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.61,
    y1: 163.74,
    x2: 166.61,
    y2: 163.74
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/LIST.6ab012cc5345338304bd76c6d3bd6291.svg";
export { ForwardRef as ReactComponent };